<template>
<div class="chapter">
<div class="inner_page">
<p><a id="c01"></a></p>
<div class="ct sgc-1">
    1
  </div>
<div class="tx1">
    What a fine view of Yongyon village that is, once you’ve climbed up this hill. The big house pointing up over there—the one with the western-style shingles—that belongs to Chong Tokho, who also owns the farmland in front of it. The tin-roofed building over to this side is the township office, the one right next to it is the police station, and those dark spots forming a circle around them are farmhouses.
  </div>
<div class="tx">
    And that blue pond down there? That’s Wonso Pond, the very lifeline of the village. It’s the reason the village was settled here in the first place, and the reason the fields were later cleared. Everyone, even the dogs and wild animals, depends on it for fresh drinking water.
  </div>
<div class="tx">
    Now there won’t be anybody around, of course, who knows just how and when the pond actually got there. But the farmers in the village have a legend to tell about it. To the villagers this is their one source of pride, and it’s become an article of faith for them.
  </div>
<div class="tx">
    If you listen to their story, this is what they’ll say:
  </div>
<div class="tx">
    Long, long ago, before the pond was ever formed, a rich official lived here, or so the story goes, with countless numbers of slaves and fields and well-fed livestock. Such a miser was this man that when he failed each year to eat all the grain he harvested, he preferred to see it rot in his storehouse rather than offer it to the farmers suffering around him. Begrudging even a spoonful of rice that the occasional beggar wandered by in search of, he made sure his front gate was locked up tight before letting anyone in the household begin cooking.
  </div>
<div class="tx">
    After several years of poor harvests, when the local people began to die of hunger, they came to plead with the official several times a day. But the man did little more than turn a deaf ear, and shooed them off with a scolding before they could pass through his front door.
  </div>
<div class="tx">
    Under these circumstances the farmers felt they had no other choice 
     but to band together and raid the official’s house, which they did one night, taking away his rice and livestock.
  </div>
<div class="tx">
    Within a few days the official filed a petition with the local authorities and had all the local farmers arrested. Those who weren’t subjected to cruel punishments or execution were banished from the area, so the story goes.
  </div>
<div class="tx">
    The children in the village who had lost their mothers and fathers and the elders who had lost their daughters and sons called out for their loved ones until their throats were raw. They cried in the man’s courtyard, refusing to leave.
  </div>
<div class="tx">
    They cried and cried, and cried even more, so that in the course of a single night they transformed the official’s splendid mansion into a pond of tears. This pond, according to the story, is the very same blue pond you see down there.
  </div>
<div class="tx">
    Now anyone can guess with a glance at its surface how wide the pond is, but there’s not a soul around who knows how deep it goes. There’s talk of someone long ago who let several spools of silk thread down into the water in order to measure its depth, but none of the spools reached the bottom.
  </div>
<div class="tx">
    Whenever new people move into the village, the first thing the farmers tell them is the legend of Wonso Pond, and as soon as children learn how to talk, their parents teach them the story. Little children and adults alike, they all know the legend by heart. And even if the facts remain somewhat obscure, they hold a certain hope in the pond.
  </div>
<div class="tx">
    It’s for this reason that the farmers seek comfort from Wonso Pond whenever they’re distressed or tormented by something—one glance at Wonso Pond and their troubles are gone, they say.
  </div>
<div class="tx">
    On the four major holidays the farmers used to carry down white rice and rice cakes and bury them beside Wonso Pond, sometimes even offering their clothes or shoes to the water. Such was the extent to which they once showed their devotion. Even people on the verge of death, they say, would come to pray at the pond and be cured of their illnesses.
  </div>
<div class="tx">
    As the years passed, their blessed Wonso Pond notwithstanding, increased suffering and misfortune for some reason fell upon the villagers. And, in recent years, with little more than wheat gruel and acorns to eat, it was a rare soul indeed who could bury white rice and rice cakes near the banks of the pond.
  </div>
<div class="tx">
    Still, the villagers were convinced that Wonso Pond alone could cure their pain and sorrow, and they continued to make a practice of looking out over the pond for comfort.
  </div>
<div class="tx">
    Today, as ever, the water in the pond is as blue as blue can be—so blue that all who see it want to dye their white clothes the color of the water.
  </div>
<div>
     <br/>
</div>
<div class="tx1">
    Down below the pond, where the eulalia reeds grow sky high, Wonso’s water trickles gently out into a stream come springtime. The ancient willow trees encircling the pond seem dead at first glance, but fresh, green buds are emerging.
  </div>
<div class="tx">
    Out of nowhere a single beetle jumps onto the surface of the pond, glides freely in a circle, and flies off once again. And then, from somewhere in the distance, comes the faint sound of footsteps approaching.
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// kang_9781558616530_oeb_c01_r1.vue?3144f8e8